import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { startPolling, stopPolling, resetPolling } from 'redux/slices/polling';

export const usePollApi = () => {
    const dispatch = useDispatch();
    const { data, isFetching, error } = useSelector((state) => state.pollApi);

    const handleStart = useCallback(
        (props) => {
            dispatch(startPolling(props));
        },
        [dispatch]
    );

    const handleStop = useCallback(() => {
        dispatch(stopPolling());
    }, [dispatch]);

    const handleReset = useCallback(() => {
        dispatch(resetPolling());
    }, [dispatch]);

    useEffect(() => {
        return () => {
            handleReset();
        };
    }, [handleReset]);

    //clear polling states when user reload page manually or close tab.
    useEffect(() => {
        window.addEventListener('beforeunload', handleReset);
        return () => {
            window.removeEventListener('beforeunload', handleReset);
        };
    }, [handleReset]);

    return {
        data,
        error,
        isFetching,
        startPolling: handleStart,
        stopPolling: handleStop,
        resetPolling: handleReset,
    };
};
